module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-input",
    class: {
      wide: _vm.wide, error: _vm.error && _vm.error.error
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.required && !_vm.noRequiredSign),
      expression: "required && !noRequiredSign"
    }],
    staticClass: "sign"
  }, [_vm._v("*")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.focus && _vm.val),
      expression: "focus && val"
    }],
    staticClass: "del"
  }, [_c('div', {
    staticClass: "icon icon-no gray",
    on: {
      "click": function($event) {
        _vm.clear();
      }
    }
  })]), _vm._v(" "), (_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onEnter();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'date') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "date",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'datetime-local') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "datetime-local",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "password",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onEnter();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onEnter();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'tel') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "tel",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onEnter();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.needFakePlaceholder()) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.val && !_vm.focus),
      expression: "!val && !focus"
    }],
    staticClass: "fake-placeholder",
    on: {
      "click": function($event) {
        _vm.clickFakePlaceholder();
      }
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error && _vm.error.error),
      expression: "error && error.error"
    }],
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.error.msg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.val && !_vm.searching && _vm.focus && _vm.onlyAllowAutoComplete && !(_vm.suggestions && _vm.suggestions.length)),
      expression: "val && !searching && focus && onlyAllowAutoComplete && !(suggestions && suggestions.length)"
    }],
    staticClass: "suggestion-hint"
  }, [_vm._v("\n        没有搜索结果\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.suggestions && _vm.suggestions.length),
      expression: "suggestions && suggestions.length"
    }],
    staticClass: "suggestion"
  }, [_c('ul', {
    class: {
      overflow: _vm.suggestions.length > 4
    }
  }, _vm._l((_vm.suggestions), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.chooseThisSuggestion(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n            ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bdaad30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Input.vue
// module id = 302
// module chunks = 1